import { render, staticRenderFns } from "./PurchaseOrderMGT.vue?vue&type=template&id=8c460e7a&scoped=true&"
import script from "./PurchaseOrderMGT.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderMGT.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderMGT.vue?vue&type=style&index=0&id=8c460e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c460e7a",
  null
  
)

export default component.exports